export default __webpack_public_path__ + "static/media/wallet.04ea3e72.svg";